// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1385) return "static/chunks/1385.ad13d6e016bad1fc.js";
	if (chunkId === 7192) return "static/chunks/7192.c86edaa7577a7389.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"71":"f243dbd346ddc16f","2487":"f732773c9ce53bdc","2582":"ae92a7bb04e5b299","6708":"99a4e9bc7c99d149","6745":"9dcc94bf0c5640c1","7749":"1863dc9adbe27105","8793":"545b1860ae81e587"}[chunkId] + ".js";
};